export const getIsComplexMultiple = (
  numberOfLines: number,
  isEachWaySelected: boolean | undefined
) => {
  if (isEachWaySelected) {
    return numberOfLines / 2 > 1;
  }

  return numberOfLines > 1;
};
